/**
 * UploadIcon/index.js
 * desc: upload icon
 * note: accessible icon-button (button + tooltip) by default; read-only renders a static glyph
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const UploadIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="upload icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.upload.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 44 30" xmlns="http://www.w3.org/2000/svg"><path d="M21.8894 0.454102C28.5292 0.454102 34.0563 5.16319 35.2967 11.4359C40.0394 11.7632 43.7788 15.6541 43.7788 20.4541C43.7788 25.4723 39.6928 29.545 34.6582 29.545H10.9447C4.90687 29.545 0 24.6541 0 18.6359C0 13.0177 4.26843 8.38137 9.75902 7.79956C12.0392 3.43592 16.6177 0.454102 21.8894 0.454102ZM25.5376 24.0905V16.8177H31.01L21.8894 7.72683L12.7688 16.8177H18.2412V24.0905H25.5376Z"/></svg>
    </IconButton>
);


export default UploadIcon;
